import { EarliestInquiryInfo } from "@/framework/network/gql/generated/graphql";

export default {
  getMemo(state: any): string {
    return state.sandboxLogoutMemo;
  },
  getIsImportInProgress(state: any): string {
    return state.isImportInProgress;
  },
  getIsUserImportingToDictionary(state: any): string {
    return state.isUserImportingToDictionary;
  },
  getInquiryInfo(state: any): EarliestInquiryInfo {
    return state.inquiryInfo;
  },
};
